import React, { Component } from 'react';
import PaymentMethodCard from '../../paymentMethods/paymentMethodComponent';
class AccountsReceivableHeader extends Component {

    render() {
        return (
            <div className="mb-4">
                {/* CARDS */}
                <div className="row">

                    {/* TRANSFERENCIA */}
                    <div className="col-md-3 mb-3">
                        <PaymentMethodCard
                            title="Transferencia"
                            icon="fas fa-university"
                            color="primary"
                            account="1101-01 Bancos"
                            total="$125,000.00"
                            extra={{
                                reference: "TRF-983472",
                                date: "22/01/2026"
                            }}
                        />
                    </div>

                    {/* CHEQUE */}
                    <div className="col-md-3 mb-3">
                        <PaymentMethodCard
                            title="Cheque"
                            icon="fas fa-money-check-alt"
                            color="warning"
                            account="1102-01 Cheques por cobrar"
                            total="$80,500.00"
                            extra={{
                                checks: [
                                    { number: "45812", amount: "35,000.00" },
                                    { number: "45813", amount: "45,500.00" }
                                ]
                            }}
                        />
                    </div>

                    {/* EFECTIVO */}
                    <div className="col-md-3 mb-3">
                        <PaymentMethodCard
                            title="Efectivo"
                            icon="fas fa-coins"
                            color="success"
                            account="1103-01 Caja"
                            total="$45,300.00"
                        />
                    </div>

                    {/* TARJETA */}
                    <div className="col-md-3 mb-3">
                        <PaymentMethodCard
                            title="Tarjeta"
                            icon="fas fa-credit-card"
                            color="info"
                            account="1104-01 Tarjetas"
                            total="$62,750.00"
                            extra={{
                                reference: "VISA / MASTERCARD",
                                date: "22/01/2026"
                            }}
                        />
                    </div>

                </div>
            </div>
        );
    }
}

export default AccountsReceivableHeader;
